import { delay } from 'redux-saga';
import { fork, select, call, put } from 'redux-saga/effects';
import api from 'api';
import { actions as statusActions } from 'state/status';
import { selectors as statusSelectors } from 'state/status';
import { statusOptions } from 'state/status/initial.state';
import { sendMessage, captureError } from 'sentry';

const SENTRY_NOTIFICATION = 'SA DOWN ACTIVATED';
const TIME = {
  ONE_MINUTE: 60000,
  TWENTY_SECONDS: 20000,
};

function* initStatusCheck() {
  try {
    yield fork(initPolling);
  } catch (e) {
    captureError(e);
  }
}

function* initPolling() {
  while (true) {
    try {
      const { data } = yield call(api.getStatus);
      const { show_page_down: showPageDown } = data || {};
      const newStatus = (showPageDown || {}).enabled
        ? statusOptions.DOWN
        : statusOptions.NORMAL;

      yield put(statusActions.setStatus(newStatus));
      yield put(statusActions.setResetNumberOfFailures());

      yield call(delay, TIME.ONE_MINUTE);
    } catch (e) {
      captureError(e);

      yield put(statusActions.setIncreaseNumberOfFailures());
      const consecutiveNumberOfFailures = yield select(
        statusSelectors.getConsecutiveNumberOfFailures
      );

      if (consecutiveNumberOfFailures >= 3) {
        yield put(statusActions.setStatus(statusOptions.DOWN));
        sendMessage(SENTRY_NOTIFICATION);
      }

      yield call(delay, TIME.ONE_MINUTE);
    }
  }
}

export default function* () {}

export { initStatusCheck, initPolling };
